import http from 'src/app/http';


const requestForAmount = () => http.get('/count')
  .then(({ data }) => data.value.toLocaleString());

export default { requestForAmount };
